import {createReducer} from '@reduxjs/toolkit'
import {
  _openNativeModal,
  closeNativeModal,
  closeUpgradeToPremium,
  openCheckoutUnavailable,
  openUpgradeToPremiumOld,
} from '../actions/modals'
import {NativeModal} from '../components/modals/constants'
import {ModalsState} from '../types/state'

const defaultState: ModalsState<NativeModal> = {
  modalType: undefined,
  payload: undefined,
}

export const modals = createReducer(defaultState, builder => {
  builder
    .addCase(_openNativeModal, (_state, action) => ({modalType: action.payload.type, payload: action.payload.payload}))
    .addCase(closeNativeModal, () => defaultState)
    .addCase(openUpgradeToPremiumOld.pending, () => defaultState)
    .addCase(openCheckoutUnavailable.pending, () => defaultState)
    .addCase(closeUpgradeToPremium.fulfilled, () => defaultState)
})
